import { render, staticRenderFns } from "./RelationshipList.vue?vue&type=template&id=7a9a4280&scoped=true"
import script from "./RelationshipList.vue?vue&type=script&lang=js"
export * from "./RelationshipList.vue?vue&type=script&lang=js"
import style0 from "./RelationshipList.vue?vue&type=style&index=0&id=7a9a4280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a4280",
  null
  
)

export default component.exports